import { render, staticRenderFns } from "./PointInfoComboBox.vue?vue&type=template&id=630be11a&scoped=true"
import script from "./PointInfoComboBox.vue?vue&type=script&lang=js"
export * from "./PointInfoComboBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630be11a",
  null
  
)

export default component.exports